(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.body = document.querySelector('body');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.promoBanner = null;
      this.promoWrapper = null;
      this.promoResizeObserver = null;
      this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.mediaQuery.addEventListener('change', this.boundSetHeaderHeight);
      window.addEventListener('load', this.boundSetHeaderHeight, { once: true });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.body.classList.add('body-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('search-form');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.initPromoOffset();
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      const chrome = this.header.querySelector('header.header') || this.header.querySelector('.header') || this.header;
      const rect = chrome.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-height', `${
        Math.max(0, Math.round(rect.height || 0))
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('load', this.boundSetHeaderHeight);
      if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.boundSetHeaderHeight);
      if (this.promoResizeObserver && this.promoWrapper) {
        this.promoResizeObserver.unobserve(this.promoWrapper);
      }
      this.promoResizeObserver = null;
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      


      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        


        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.body.classList.add('body-hidden', 'body-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.body.classList.add('body-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.body.classList.remove('body-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.body.classList.remove('body-hidden', 'body-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      } else {
        const searchDrawer = document.getElementById('SearchDrawer');
        if (searchDrawer && searchDrawer.classList.contains('active')) {
          searchDrawer.close();
        }
      }
    }

    initPromoOffset() {
      if (typeof ResizeObserver === 'undefined') {
        this.updatePromoOffset();
        return;
      }

      this.promoBanner = document.querySelector('.floating-promo-banner[data-place-above-header="true"]') || document.querySelector('.floating-promo-banner[data-place-above-header="True"]');

      if (!this.promoBanner) {
        this.updatePromoOffset();
        return;
      }

      this.promoWrapper = this.promoBanner.querySelector('[data-promo-wrapper]') || this.promoBanner;
      this.updatePromoOffset();

      this.promoResizeObserver = new ResizeObserver(() => {
        this.updatePromoOffset();
      });
      this.promoResizeObserver.observe(this.promoWrapper);
    }

    updatePromoOffset() {
      const isAboveHeader = this.promoBanner
        ? String(this.promoBanner.dataset.placeAboveHeader).toLowerCase() === 'true'
        : false;

      if (!this.promoBanner || ! isAboveHeader) {
        document.documentElement.style.setProperty('--promo-banner-height', '0px');
        return;
      }

      const wrapper = this.promoWrapper || this.promoBanner;
      const rect = wrapper.getBoundingClientRect();
      const offset = Math.max(0, Math.round(rect.height || 0));
      document.documentElement.style.setProperty('--promo-banner-height', `${offset}px`);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
